import { ColorInterface, ColorInterfaceTopbar } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';

@Component({
  selector: 'app-sbeditor-tool-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  public topbar: ColorInterfaceTopbar = null;
  public subscriptions: Array<Subscription>
  @Output() exportTool = new EventEmitter<ColorInterfaceTopbar>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
      const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
        this.topbar = Object.assign({},res.color.manual.topbar);
        // console.log('Topbar: ', this.topbar);
      });
      this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  public getTool(){
    return this.topbar;
  }

}
